export default "__VITE_ASSET__BjdCdVoE__"